import * as classes from './mini-widget.css';
import { Position, positionState } from '../core/widget-position';

export const positionMapping = {
  [Position.RightTop]: `${classes.wrapperRight} ${classes.wrapperRightTop}`,
  [Position.RightMiddle]: `${classes.wrapperRight} ${classes.wrapperRightMiddle}`,
  [Position.RightBottom]: `${classes.wrapperRight} ${classes.wrapperRightBottom}`,
  [Position.LeftTop]: `${classes.wrapperLeft} ${classes.wrapperLeftTop}`,
  [Position.LeftMiddle]: `${classes.wrapperLeft} ${classes.wrapperLeftMiddle}`,
  [Position.LeftBottom]: `${classes.wrapperLeft} ${classes.wrapperLeftBottom}`,
};

export const getPositionClass = (position: number) => {
  const value = positionState(position);
  return positionMapping[value as keyof typeof positionMapping];
};
